export const patientRegistrationPageSelectors = {
  container: 'patient-registration-page',
  firstNameInput: 'patient-registration-first-name-input',
  lastNameInput: 'patient-registration-last-name-input',
  dateOfBirthInput: 'patient-registration-date-of-birth-input',
  phoneNumberInput: 'patient-registration-phone-number-input',
  submitButton: 'patient-registration-submit-button'
};
